export enum HeartbeatStatus {
    Unknown = 0,
    Normal = 1,
    Warning = 2,
    Error = 3,
}
